import _slicedToArray from "/tmp/build_f973a96b/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React$1, { useState, useMemo } from 'react';
import { PortalsManagerContext } from '../../utilities/portals/context.js';
import { PortalsContainer as PortalsContainer$1 } from './components/PortalsContainer/PortalsContainer.js';
function PortalsManager(_ref) {
  var children = _ref.children,
    container = _ref.container;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    portalContainerElement = _useState2[0],
    setPortalContainerElement = _useState2[1];
  var currentContainer = container != null ? container : portalContainerElement;
  var contextValue = useMemo(function () {
    return {
      container: currentContainer
    };
  }, [currentContainer]);
  return /*#__PURE__*/React$1.createElement(PortalsManagerContext.Provider, {
    value: contextValue
  }, children, container ? null : /*#__PURE__*/React$1.createElement(PortalsContainer$1, {
    ref: setPortalContainerElement
  }));
}
export { PortalsManager };